export const title = {
  mb: 3,
  fontSize: 24,
  fontWeight: 700,
}

export const tableBox = {
  borderRadius: 2,
  boxShadow: "none",

  "& .MuiTableCell-root": {
    whiteSpace: "nowrap",
    "&.MuiTableCell-body": {
      height: 60,
    },
  },
}

export const tableHead = {
  backgroundColor: "white",
  "& .MuiTableCell-root": {
    padding: 0,
    minHeight: 18,
    fontSize: 13,
    lineHeight: "1.25rem",
    fontWeight: 400,
    color: "tableTitleGray",
    border: "none",
  },
}

export const tableHeadRow = {
  height: 35,
  verticalAlign: "top",
}

export const tableEmptyWrapper = {
  borderTop: { xs: "1px solid #DCDCDC", md: "unset" },
  p: 2,
  display: "flex",
  width: "100%",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}

export const tableEmptyText = {
  fontWeight: 600,
  mb: { xs: 1, md: 2, lg: 3 },
}
